export default __webpack_public_path__ + "static/rostyslav-pidburachynskyi-33f1a78c63bc79cbd734d938c7f8c999.png";